import React, { Component } from 'react';
import { TrashButton } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import styles from '../../domainManager/style.scss';
import DeleteDialog from '../../../portal/dialogs/deleteDialog';
import erorrHandler from '../../../../services/web/erorrHandler';
import ErrorDialog from '../../../portal/dialogs/errorDialog';
import ToastrService from '../../../../services/ui/toastrService';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';

export default class RemoveDomainButton extends Component {

    state = {
        openDeleteDialog: false,
        openErrorDialog: false
    };


    openDeleteDialog = () => {

        this.setState({
            openDeleteDialog: true
        });
    }

    closeDeleteDialog = () => {

        this.setState({
            openDeleteDialog: false
        });
    }

    openErrorDialog = () => {

        this.setState({
            openErrorDialog: true,
            openDeleteDialog: false
        });
    }

    closeErrorDialog = () => {

        this.setState({
            openErrorDialog: false
        });
    }

    removeDomain = () => {

        this.props.deleteDomain(this.props.id)
            .then(() => {

                this.closeDeleteDialog();
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translations.DOMAIN_DELETE_SUCCESS_MESSAGE;
                ToastrService.triggerToastr({ level, message });

            })
            .catch((error) => {
                this.errorDialogMessage = erorrHandler.getErrorMessage(error);
                this.openErrorDialog();
            });
    }

    render() {
        
        const { name, translations } = this.props;
        const message = 
            <div>
                {translations.DOMAIN_WILL_REMOVE.replace('{name}', name)}
                <br />
                {translations.DELETING_DOMAIN_CONFIRM_WILL_DELETE_USER}
            </div>;

        return (
            <div>
                <TrashButton
                    onClick={this.openDeleteDialog}
                    dataCy={`btn-delete-domain_${name}`}
                    className={classNames(styles.actionIcons)}
                />
                <DeleteDialog
                    show={this.state.openDeleteDialog}
                    onConfirm={this.removeDomain}
                    deleteButtonText={translations.REMOVE}
                    cancelText={translations.CANCEL}
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={translations.REMOVE_DOMAIN}
                    contentText={message}
                    dialogDataCy='delete-domain-confirmation-alert'
                    dataCy='delete-domain-button'
                />
                <ErrorDialog
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translations.CLOSE}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translations.ERROR}
                    contentText={this.errorDialogMessage}
                />
            </div>
        );
    }
}